export default __webpack_public_path__ + "static/media/Giannekas.716b774a.png";